export const CONST_EXPRESSION = [
    [
        {content: '😀', code: '\uD83D\uDE00'},
        {content: '😃', code: '\uD83D\uDE03'},
        {content: '😄', code: '\uD83D\uDE04'},
        {content: '😁', code: '\uD83D\uDE01'},
        {content: '😆', code: '\uD83D\uDE06'},
        {content: '😅', code: '\uD83D\uDE05'},
        {content: '😂', code: '\uD83D\uDE02'},
        {content: '🙂', code: '\uD83D\uDE42'},
        {content: '🙃', code: '\uD83D\uDE43'},
        {content: '😉', code: '\uD83D\uDE09'},
        {content: '😊', code: '\uD83D\uDE0A'},
        {content: '😇', code: '\uD83D\uDE07'},
        {content: '😍', code: '\uD83D\uDE0D'},
        {content: '😘', code: '\uD83D\uDE18'},
        {content: '😗', code: '\uD83D\uDE17'},
        {content: '😚', code: '\uD83D\uDE1A'},
        {content: '😙', code: '\uD83D\uDE19'},
        {content: '😋', code: '\uD83D\uDE0B'},
        {content: '😛', code: '\uD83D\uDE1B'},
        {content: '😜', code: '\uD83D\uDE1C'},
        {content: '😝', code: '\uD83D\uDE1D'},
        {content: '🤑', code: '\uD83E\uDD11'},
        {content: '🤗', code: '\uD83E\uDD17'},
        {content: '🤔', code: '\uD83E\uDD14'},
        {content: '🤐', code: '\uD83E\uDD10'},
        {content: '😐', code: '\uD83D\uDE10'},
        {content: '😑', code: '\uD83D\uDE11'},
        {content: '😶', code: '\uD83D\uDE36'},
        {content: '😏', code: '\uD83D\uDE0F'},
        {content: '😒', code: '\uD83D\uDE12'},
        {content: '🙄', code: '\uD83D\uDE44'},
        {content: '😬', code: '\uD83D\uDE2C'},
        {content: '😌', code: '\uD83D\uDE0C'},
        {content: '😔', code: '\uD83D\uDE14'}
    ],
    [
        {content: '😪', code: '\uD83D\uDE2A'},
        {content: '😴', code: '\uD83D\uDE34'},
        {content: '😷', code: '\uD83D\uDE37'},
        {content: '🤒', code: '\uD83E\uDD12'},
        {content: '🤕', code: '\uD83E\uDD15'},
        {content: '😵', code: '\uD83D\uDE35'},
        {content: '😎', code: '\uD83D\uDE0E'},
        {content: '🤓', code: '\uD83E\uDD13'},
        {content: '😕', code: '\uD83D\uDE15'},
        {content: '😟', code: '\uD83D\uDE1F'},
        {content: '🙁', code: '\uD83D\uDE41'},
        {content: '😮', code: '\uD83D\uDE2E'},
        {content: '😯', code: '\uD83D\uDE2F'},
        {content: '😲', code: '\uD83D\uDE32'},
        {content: '😳', code: '\uD83D\uDE33'},
        {content: '😦', code: '\uD83D\uDE26'},
        {content: '😧', code: '\uD83D\uDE27'},
        {content: '😨', code: '\uD83D\uDE28'},
        {content: '😰', code: '\uD83D\uDE30'},
        {content: '😥', code: '\uD83D\uDE25'},
        {content: '😢', code: '\uD83D\uDE22'},
        {content: '😭', code: '\uD83D\uDE2D'},
        {content: '😱', code: '\uD83D\uDE31'},
        {content: '😖', code: '\uD83D\uDE16'},
        {content: '😣', code: '\uD83D\uDE23'},
        {content: '😞', code: '\uD83D\uDE1E'},
        {content: '😓', code: '\uD83D\uDE13'},
        {content: '😩', code: '\uD83D\uDE29'},
        {content: '😫', code: '\uD83D\uDE2B'},
        {content: '😤', code: '\uD83D\uDE24'},
        {content: '😡', code: '\uD83D\uDE21'},
        {content: '😠', code: '\uD83D\uDE20'},
        {content: '😈', code: '\uD83D\uDE08'},
        {content: '👿', code: '\uD83D\uDC7F'}
    ],
    [
        {content: '😺', code: '\uD83D\uDE3A'},
        {content: '😸', code: '\uD83D\uDE38'},
        {content: '😹', code: '\uD83D\uDE39'},
        {content: '😻', code: '\uD83D\uDE3B'},
        {content: '😼', code: '\uD83D\uDE3C'},
        {content: '😽', code: '\uD83D\uDE3D'},
        {content: '🙀', code: '\uD83D\uDE40'},
        {content: '😿', code: '\uD83D\uDE3F'},
        {content: '😾', code: '\uD83D\uDE3E'},
        {content: '👀', code: '\uD83D\uDC40'},
        {content: '👌', code: '\uD83D\uDC4C'},
        {content: '👈', code: '\uD83D\uDC48'},
        {content: '👉', code: '\uD83D\uDC49'},
        {content: '👆', code: '\uD83D\uDC46'},
        {content: '👇', code: '\uD83D\uDC47'},
        {content: '👍', code: '\uD83D\uDC4D'},
        {content: '👎', code: '\uD83D\uDC4E'},
        {content: '👊', code: '\uD83D\uDC4A'},
        {content: '🙏', code: '\uD83D\uDE4F'},
        {content: '💪', code: '\uD83D\uDCAA'},
        {content: '💋', code: '\uD83D\uDC8B'},
        {content: '💌', code: '\uD83D\uDC8C'},
        {content: '💘', code: '\uD83D\uDC98'},
        {content: '💝', code: '\uD83D\uDC9D'},
        {content: '💖', code: '\uD83D\uDC96'},
        {content: '💞', code: '\uD83D\uDC9E'},
        {content: '💕', code: '\uD83D\uDC95'},
        {content: '💔', code: '\uD83D\uDC94'},
        {content: '💯', code: '\uD83D\uDCAF'},
        {content: '💥', code: '\uD83D\uDCA5'},
        {content: '💫', code: '\uD83D\uDCAB'},
        {content: '💦', code: '\uD83D\uDCA6'},
        {content: '💨', code: '\uD83D\uDCA8'},
        {content: '💭', code: '\uD83D\uDCAD'}
    ],
    [
        {content: '🌸', code: '\uD83C\uDF38'},
        {content: '🌹', code: '\uD83C\uDF39'},
        {content: '🌺', code: '\uD83C\uDF3A'},
        {content: '🌱', code: '\uD83C\uDF31'},
        {content: '🌲', code: '\uD83C\uDF32'},
        {content: '🌳', code: '\uD83C\uDF33'},
        {content: '🌴', code: '\uD83C\uDF34'},
        {content: '🌿', code: '\uD83C\uDF3F'},
        {content: '🍀', code: '\uD83C\uDF40'},
        {content: '💤', code: '\uD83D\uDCA4'},
        {content: '💣', code: '\uD83D\uDCA3'},
        {content: '💩', code: '\uD83D\uDCA9'},
        {content: '💀', code: '\uD83D\uDC80'},
        {content: '👻', code: '\uD83D\uDC7B'},
        {content: '👽', code: '\uD83D\uDC7D'}
    ]
];